import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Decision } from "@/api/model/Decision";
import { FactorResource } from "@/api/model/FactorResource";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import _ from "lodash";

config.rawError = true

const name = 'decision';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({dynamic: true, store, name: name, namespaced: true})
export default class DecisionModule extends VuexModule {

    decision: Decision | null = null;
    factors: FactorResource[] = [];

    @Mutation
    setDecision(decision: Decision | null) {
        this.decision = decision;
    }

    @Mutation
    setFactorResources(factorResources: FactorResource[]) {
        this.factors = factorResources;
    }

    get factorResourceMap(): { [id: string]: FactorResource } {
        return _.keyBy(this.factors, 'id')
    }

    @Action
    async getDecision() {
        let decisions = await VIEWPOINT_API.getDecisions();
        let sanoDecision = decisions.find(f => f.createdFromTemplateId === 'SANO')
        if (sanoDecision) {
            this.setDecision(sanoDecision);
        } else {
            // sanoDecision = {modelId: ""} as Decision
            sanoDecision = await this.createDecision();
            this.setDecision(sanoDecision);
        }
        let factorResourcesFuture = VIEWPOINT_API.getModelFactorResources(sanoDecision.modelId, 'published')
        let viewpointFuture = getModule(ViewpointsModule).getViewpoints(sanoDecision.decisionId);
        this.setFactorResources(await factorResourcesFuture)
        await viewpointFuture;
        return sanoDecision;
    }

    @Action
    async createDecision() {
        let newDecision = await VIEWPOINT_API.createDecision("Home Decision", "Your home selection decision");
        this.setDecision(newDecision);
        return newDecision;
    }

    @Action
    async clear() {
        this.setDecision(null)
        this.setFactorResources([])
    }


}